/*
==========================================================
AVA VISION CONTEXT
American Global
==========================================================
*/
let latestVision = null;
let latestFrame = null;
export function setLatestVision(vision) {
    latestVision = {
        ...vision,
        scene: vision.scene ?? {},
    };
}
export function getLatestVision() {
    return latestVision;
}
export function clearLatestVision() {
    latestVision = null;
}
export function setLatestFrame(frame) {
    latestFrame = frame;
}
export function getLatestFrame() {
    return latestFrame;
}
